module.exports = __webpack_public_path__ + "static/L2_ux_5_4_eg-edd8f660c0bcfc9786bcb60454b9197c.png";